const ErrorPage = () => null;

export default ErrorPage;
